
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiNotStarted as ObiNotStartedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-not-started.js';
 
 
 

 
 export const ObiNotStarted = createComponent({
   react: React,
   tagName: 'obi-not-started',
   elementClass: ObiNotStartedElement,
   events: {
     
   }
  });
 
 